import React from 'react';
import styled from 'styled-components/macro';
import ContentBlock from '../ContentBlock';
import Visual from './images/img-experiments.jpg';
import BehanceIcon from './images/icon-contact-behance.svg';
import DribbbleIcon from './images/icon-contact-dribbble.svg';

const Quote = styled.div`
  font-size: 16px;
  line-height: 1.63;
  text-align: center;
  color: #777777;
  max-width: 250px;
  margin: 1em;
`;

const Link = styled.a`
  display: inline-block;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.33;
  text-align: center;
  color: #947ec7 !important;
  text-decoration: none;
  margin-bottom: 5em;
`;

const Experiments = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 2em;

  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  max-width: 170px;
`;

const Separator = styled.span`
  display: inline-block;
  height: 18px;
  opacity: 0.4;
  border: solid 0.8px #9b9b9b;
`;

const LatestBehancePost = props => (
  <ContentBlock image={Visual} imagePosition="right">
    <center>
      <h3>Personal AI Chatbot Assistant Concept</h3>
      <Quote>
        “We are very happy to make our debut shot and join the community with
        this AI powered personal assistant chatbot animation.”
      </Quote>
      <Link
        href="https://dribbble.com/shots/5780376-Personal-AI-Chatbot"
        target="_blank"
        rel="noopener noreferrer"
      >
        See post >
      </Link>
      <h4 style={{ maxWidth: '180px' }}>Check out our design experiments:</h4>
      <Experiments>
        <a
          href="https://dribbble.com/361studio"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={DribbbleIcon} alt="Dribbble" />
        </a>
        <Separator />
        <a
          href="https://www.behance.net/361studio"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={BehanceIcon} alt="Behance" />
        </a>
      </Experiments>
    </center>
  </ContentBlock>
);

LatestBehancePost.propTypes = {};

LatestBehancePost.defaultProps = {};

export default LatestBehancePost;
